import { CategoryKey } from '@aibees/shared/features';

import {
  PROFILE_INSIGHT_CATEGORIES,
  PROFILE_INSIGHT_FIELDS,
} from './profile-insight-fields';

export function hasProfileInsightFields(
  exportSetting?: Record<string, any>
): boolean {
  if (!exportSetting) return false;

  for (const key in exportSetting) {
    const item = exportSetting[key];

    if (PROFILE_INSIGHT_CATEGORIES.includes(key)) {
      if (Array.isArray(item)) {
        if (item.some((entry) => entry.fields?.length > 0)) return true;
      } else if (item?.fields?.length > 0) {
        return true;
      }
    } else if (key === CategoryKey.basic) {
      // Field-level profile-insight fields only exist in People Basic. This
      // mirrors the info-badge gating in options-converter and prevents shared
      // keys such as SLUG (also present in Company Basic) from wrongly
      // triggering the mismatch dialog outside People Basic.
      if (
        item?.fields?.some((f: string) => PROFILE_INSIGHT_FIELDS.includes(f))
      ) {
        return true;
      }
    }
  }
  return false;
}
